/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments.
 */

export default {
  name: 'dashify:HeatMap',
  title: 'HeatMap',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'heatmap'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'Jan 16, 2024, 2:18 PM',
  spec: {
    props: {},
    defaultStops: [
      [0, 'darkgray'],
      [0.001, '#D9DDFF'],
      [0.25, '#CCD1FF'],
      [0.5, '#BAC1FF'],
      [0.75, '#8A95FF'],
      [1, '#6977F0'],
    ],
    defaults: {
      chart: {
        type: 'heatmap',
        plotBorderWidth: 0,
        plotShadow: false,
        style: {
          fontFamily: 'var(--typography-font-body)',
        },
        styledMode: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: '',
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
        categories: [],
      },
      yAxis: {
        categories: [],
        title: null,
        distance: 5,
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
      },
      colorAxis: {
        min: 0,
        className: null, // Disable the default class
        lineColor: 'transparent', // Set the color of the axis line to transparent
        tickWidth: 0, // Set the width of the tick marks to 0 to hide them
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
        stops: '/${ props.colorAxis.stops ? props.colorAxis.stops : defaultStops }',
      },
      legend: {
        enabled: true,
        align: 'right',
        layout: 'vertical',
        margin: 10,
        verticalAlign: 'middle',
        y: 0,
        symbolHeight: 500,
        symbolWidth: 10,
      },
      plotOptions: {
        heatmap: {
          borderColor: 'var(--color-default-bg-weak)',
          borderWidth: 0.5,
          dataLabels: {
            enabled: true,
            useHTML: true,
            style: {
              textOutline: 'none',
              inside: true,
              fontFamily: 'var(--typography-font-body)',
              fontSize: '11px',
              fontStyle: 'normal',
              fontWeight: '400',
              color: '#6f7680',
              backgroundColor: 'var(--color-default-bg)',
            },
          },
        },
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: function (event: any) {
                var str =
                  event.point.series.yAxis.categories[event.point.y] +
                  ', ' +
                  event.point.series.xAxis.categories[event.point.x];
                alert('Implement drilldown to ECP for [' + str + ']');
              },
            },
          },
        },
      },
      series: [
        {
          name: '',
          data: [],
          keys: ['x', 'y', 'value', 'instanceid', 'name'],
        },
      ],
      tooltip: {
        useHTML: true,
        outside: true,
        backgroundColor: 'var(--color-default-bg)',
        style: {
          fontFamily: 'var(--typography-font-body)',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'var(--color-default-text)',
          backgroundColor: 'var(--color-default-bg)',
        },
        formatter: function (this: any) {
          const axisValues =
            this.series.xAxis.categories.length > 0 && this.series.yAxis.categories.length > 0
              ? this.series.xAxis.categories[this.point.x] + ', ' + this.series.yAxis.categories[this.point.y] + '<br/>'
              : '';
          return axisValues + this.point.name + '<br/>' + '<b>' + this.point.value == null
            ? 'N/a'
            : this.point.value + '</b>';
        },
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    },
    view: [
      [
        'div',
        {
          '.': 'grow',
        },
        [['dashify:Highcharts', '/${ $defaultsDeep({}, props, defaults) }']],
      ],
    ],
  },
};
